import { render, staticRenderFns } from "./TowerSettingsDeliveryPrice.vue?vue&type=template&id=1193971e"
import script from "./TowerSettingsDeliveryPrice.vue?vue&type=script&lang=js"
export * from "./TowerSettingsDeliveryPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports